<cms-disruptions *ngIf="disruptions$ | async as disruptions" [disruptions]="disruptions"></cms-disruptions>
<cms-disruptions
  *ngIf="personalizedDisruptions$ | async"
  [disruptions]="personalizedDisruptions$ | async"
></cms-disruptions>

<div class="relative overflow-hidden">
  <fin-content-image
    *ngIf="backgroundImage"
    [aspectRatio$]="'16x9' | finToObservable"
    [fillParent]="true"
    [imageData$]="backgroundImage | finToObservable"
    [scale]="false"
  >
  </fin-content-image>

  <div class="relative grid-col-12 grid-max-width pr-xlarge-y">
    <section class="col-f sm-col-2-11 md-col-3-10">
      <ng-container *ngTemplateOutlet="pnrWidgetContent"></ng-container>
    </section>
  </div>
</div>

<ng-template #pnrWidgetContent>
  <ng-container *ngTemplateOutlet="tabsContentWithUpcomingTrips"> </ng-container>
</ng-template>

<ng-template #loginVerifyLoader>
  <div class="align-center login-verify-loader" data-testid="login-verify-loading">
    <ng-container *ngTemplateOutlet="loader"></ng-container>
  </div>
</ng-template>

<ng-template #loader>
  <div class="ps-xxsmall-b grey-600-text font-body-1" aria-live="assertive">
    <fcom-loader [loaderType]="LoaderTheme.INLINE_TEXT"></fcom-loader>
    {{ 'actions.loading' | finLocalization }}
  </div>
</ng-template>

<ng-template #formLoaderContent>
  <div class="align-center" *ngIf="loading" data-testid="form-loading">
    <ng-container *ngTemplateOutlet="loader"></ng-container>
    <fcom-button
      data-testid="cancel-retrieve"
      [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
      [text]="'actions.cancel' | finLocalization"
      (clickBtn)="cancelRetrieve.emit()"
    ></fcom-button>
  </div>
</ng-template>

<ng-template #tabsContentWithUpcomingTrips>
  <div class="grey-25-bg rounded-large shadow ps-medium">
    <ng-container *ngTemplateOutlet="mmbTitle"></ng-container>
    <ng-container *ngTemplateOutlet="loading ? formLoaderContent : pnrWidgetTabs"></ng-container>
  </div>
  <ng-container *ngTemplateOutlet="cmsArticleContent"></ng-container>
</ng-template>

<ng-template #pnrWidgetTabs>
  <fcom-tabs
    class="ps-medium-t"
    [theme]="TabTheme.DEFAULT"
    [bottomBorder]="false"
    [whiteSpaceNowrap]="true"
    (clickedTab)="setActiveTab($event)"
    [prevButtonAriaLabel]="'carousel.previous' | finLocalization"
    [nextButtonAriaLabel]="'carousel.next' | finLocalization"
    data-testid="mmb-widget-tabs"
  >
    <fcom-tab
      [title]="'MMB.upcomingTrips.bookingReferenceTab.title' | finLocalization"
      [tabTitleDataTestId]="'find-with-booking-ref-tab'"
      [attr.data-testid]="'mmb-widget-tabs-' + MmbWidgetTab.FIND_WITH_BOOKING_REFERENCE"
      [active]="(activeTab$ | async) === MmbWidgetTab.FIND_WITH_BOOKING_REFERENCE"
    >
      <ng-container *ngTemplateOutlet="findWithBookingReference"></ng-container>
    </fcom-tab>
    <fcom-tab
      [title]="'MMB.upcomingTrips.tripsTab.title' | finLocalization"
      [tabTitleDataTestId]="'upcoming-trips-tab'"
      [attr.data-testid]="'mmb-widget-tabs-' + MmbWidgetTab.UPCOMING_TRIPS"
      [active]="(activeTab$ | async) === MmbWidgetTab.UPCOMING_TRIPS"
      [disabled]="disableUpcomingTripsTab()"
    >
      <ng-container [ngTemplateOutlet]="upcomingTripsTab"></ng-container>
    </fcom-tab>
  </fcom-tabs>
</ng-template>

<ng-template #upcomingTripsTab>
  <ng-container *ngIf="(isLoginStatusVerificationLoaderOn$ | async) === false; else loginVerifyLoader">
    <ng-container
      *ngIf="(showMyTripsToLoggedUser$ | async) && !showNoTripsNotification()"
      [ngTemplateOutlet]="upcomingTrips"
    ></ng-container>
    <ng-container *ngIf="(showMyTripsToLoggedUser$ | async) === false" [ngTemplateOutlet]="loginCard"></ng-container>
    <ng-container *ngIf="showNoTripsNotification()" [ngTemplateOutlet]="noUpcomingTripsNotification"></ng-container>
  </ng-container>
</ng-template>
<ng-template #loginCard>
  <fin-login-card
    [benefitMode]="'text'"
    [benefitText]="'MMB.upcomingTrips.tripsTab.loginCard.message'"
    [title]="'MMB.upcomingTrips.tripsTab.loginCard.title'"
  ></fin-login-card>
</ng-template>

<ng-template #upcomingTrips>
  <fin-upcoming-trips
    [checkForUpgradesTripLink]="checkForUpgradesTripLink"
    (viewDetailsClicked)="viewBookingDetails($event)"
    (noTripsNotificationActivated)="onNoTripsNotification($event)"
    (errorWhenFetchingTrips)="onErrorFetchingTripsNotification($event)"
  ></fin-upcoming-trips>
</ng-template>

<ng-template #findWithBookingReference>
  <ng-container
    *ngTemplateOutlet="
      findWithBookingReferenceContent;
      context: { loginVerificationStatusLoaderOn: isLoginStatusVerificationLoaderOn$ | async }
    "
  ></ng-container>
</ng-template>

<ng-template #cmsArticleContent>
  <ng-container *ngIf="cmsArticle$ | async as cmsArticle">
    <div class="ps-medium-t" *ngIf="!operator">
      <div class="white-bg rounded-large shadow ps-medium flex mobile-column" data-testid="pnr-widget-info-block">
        <div class="flex-1 flex--basis0" *ngIf="cmsArticle.picture">
          <fin-content-image
            [aspectRatio$]="'16x9' | finToObservable"
            [imageData$]="cmsArticle.picture | finToObservable"
            [scale]="false"
          >
          </fin-content-image>
        </div>
        <div class="flex-1 flex--basis0 ps-medium">
          <h2 class="font-heading-4 pr-small-b" *ngIf="cmsArticle.teaserTitle">{{ cmsArticle.teaserTitle }}</h2>

          <fin-dynamic-html [innerHtml]="cmsArticle.teaserText"></fin-dynamic-html>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #mmbTitle>
  <div class="flex">
    <h1 class="flex-2 flex--basis0 nordic-blue-900-text font-heading-3 ps-large-b" data-testid="header-title">
      {{ widgetTitle | finLocalization }}
    </h1>
    <div *ngIf="tourOperatorImage?.responsiveImageLinksData" class="flex-1 flex--basis0 align-right">
      <div class="tour-operator-logo inline-block">
        <fcom-image [imageData]="tourOperatorImage" [scale]="false"></fcom-image>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #findWithBookingReferenceContent let-loginVerificationLoaderOn="loginVerificationStatusLoaderOn">
  <ng-container *ngTemplateOutlet="errorFetchingUpcomingTripsNotification"></ng-container>
  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" autocomplete="off">
    <ng-container *ngTemplateOutlet="formLoaderContent"></ng-container>
    <ng-container *ngIf="loginVerificationLoaderOn" [ngTemplateOutlet]="loginVerifyLoader"></ng-container>
    <div class="flex mobile-column" *ngIf="!loading && !loginVerificationLoaderOn">
      <fcom-text-input
        class="flex-1 flex--basis0 ms-large-b"
        data-testid="pnr-widget-input-recloc"
        [parentForm]="loginForm"
        [displayMargin]="false"
        [controlName]="'recLoc'"
        [required]="false"
        [translationPrefix]="(operator ? 'loginFields' : translationPrefix) + '.recLoc'"
        [placeHolder]="(operator ? 'loginFields.' + operator : translationPrefix) + '.recLoc.example'"
        [translationErrorPrefix]="
          (operator ? 'loginFields.' + operator : translationPrefix) + '.recLoc.validationMessages'
        "
      ></fcom-text-input>

      <div class="ps-medium-r"></div>

      <fcom-text-input
        class="flex-1 flex--basis0 ms-large-b"
        data-testid="pnr-widget-input-lastname"
        [parentForm]="loginForm"
        [displayMargin]="false"
        [controlName]="'lastName'"
        [required]="false"
        [translationPrefix]="operator ? 'loginFields.lastName' : translationPrefix + '.lastName'"
        [placeHolder]="operator ? 'loginFields.lastName.example' : translationPrefix + '.lastName.example'"
        [translationErrorPrefix]="
          !operator ? translationPrefix + '.lastName.validationMessages' : 'loginFields.lastName.validationMessages'
        "
      ></fcom-text-input>
    </div>

    <div class="flex content-container" data-testid="pnr-widget-content-container" *ngIf="!loading">
      <div class="flex flex-1 flex--basis0 flex--column">
        <ng-content select="[info-links]"></ng-content>
      </div>

      <fcom-button
        class="button-container"
        data-testid="pnr-widget-submit-button"
        *ngIf="!loading && !loginVerificationLoaderOn"
        [type]="ButtonType.SUBMIT"
        [size]="ButtonSize.LARGE"
        [mode]="ButtonMode.FILL_MOBILE"
        [theme]="ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
        [text]="buttonText | finLocalization"
        [attr.aria-label]="'MMB.login.submitAria' | finLocalization"
        (mousedown)="$event.preventDefault()"
        [icon]="{
          name: SvgLibraryIcon.ARROW_RIGHT,
          position: IconPosition.RIGHT,
        }"
      >
      </fcom-button>
    </div>
    <fcom-notification
      data-error-notification
      *ngIf="error$ | async as error"
      [theme]="NotificationTheme.ALERT"
      [layout]="NotificationLayout.BLOCK"
      [isClosable]="true"
      class="ms-large-t block"
      aria-live="polite"
      (closeClick)="clearError.emit()"
    >
      {{ error | finLocalization }}
    </fcom-notification>
  </form>
</ng-template>

<ng-template #noUpcomingTripsNotification>
  <div class="flex flex--column no-upcoming-trips-block">
    <fcom-notification
      [theme]="NotificationTheme.INFO"
      [layout]="NotificationLayout.BLOCK"
      [iconName]="SvgLibraryIcon.INFO_BLOCK"
      class="block"
      [class.mr-xxsmall-b]="true"
    >
      <div class="flex flex--column">
        <p class="no-trips-message">
          {{ 'MMB.upcomingTrips.bookingReferenceTab.notification.noTripsMessage' | finLocalization }}
        </p>
      </div>
    </fcom-notification>
    <div class="flex flex--center no-trips-action-buttons">
      <fcom-button
        data-testid="find-with-booking-ref-button"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        [mode]="ButtonMode.FILL"
        [text]="'MMB.upcomingTrips.tripsTab.noTrips.button.findWithBookingReference' | finLocalization"
        (clickBtn)="setActiveTab({ index: MmbWidgetTab.FIND_WITH_BOOKING_REFERENCE })"
      ></fcom-button>
    </div>
  </div>
</ng-template>

<ng-template #errorFetchingUpcomingTripsNotification>
  <fcom-notification
    *ngIf="showErrorFetchingTripsNotification()"
    [theme]="NotificationTheme.WARNING"
    [layout]="NotificationLayout.BLOCK"
    [iconName]="SvgLibraryIcon.ALERT_TRIANGLE"
    [isClosable]="true"
    class="block"
    [class.mr-xxsmall-b]="true"
    (closeClick)="showErrorFetchingTripsNotification.set(false)"
  >
    {{ 'MMB.upcomingTrips.bookingReferenceTab.notification.error' | finLocalization }}
  </fcom-notification>
</ng-template>

<ng-content select="[modal-info]"></ng-content>
